import { useConnect } from '@lore/query-connect';

export default function useInvitationsReal(state, network, schoolStart, schoolEnd, extra = {}, eager = {}) {
  return useConnect('invitation.find', {
    where: {
      eager: {
        $where: {
          event: {
            $where: {
              site: {
                $where: {
                  state: {
                    $ilike: state
                  }
                }
              }
            }
          },
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          },
          ...extra,
          request: { $not: 'Outreach' }
        },
        $eager: eager
      }
    },
    pagination: {
      pageSize: 1000
    }
  });
}
